export const myContentI18n = {
  en: {
    gridView: 'Grid view',
    listView: 'List view',
    confirmRemoveDraft: 'Are you sure you want to delete this subject?',
    booksPurchased: 'Books purchased',
    coursesPurchased: 'Subjects purchased',
    notItemsSection: 'You don\'t have content in this section for the moment',
    view: 'View',
    editContent: 'Edit content',
    editProduct: 'Edit product',
    removeDraft: 'Delete draft',
    download: 'Download',
    cover: 'Cover',
    title: 'Title',
    teacher: 'Teacher',
    subject: 'Subject',
    actions: 'Actions',
    seeAll: 'See all',
    by: 'By: ',
    byMe: 'By: Me',
    createCourse: 'Create subject',
    createBook: 'Create Book',
    draft: 'DRAFT',
    uploading: 'UPLOADING',
    conflict: 'CONFLICT',
    statusSyncDone: 'It is synchronized',
    statusSyncPending: 'It is pending to synchronize',
    statusSyncProcess: 'It being synchronized right now',
    statusSyncOut: 'It hasn\'t been synchronized yet',
    statusSyncReadyDownload: 'It can use the subject builder',
    itemMenu: {
      view: 'View',
      editContent: 'Edit content',
      editDescription: 'Edit description',
      copyToTemplate: 'Copy to template',
      copyToSubject: 'Copy to subject',
      getSubject: 'Get subject',
      remove: 'Delete',
      download: 'Download',
      courseAdmin: 'Subject admin',
      templateAdmin: 'Template admin',
      subjectBuilder: 'Subject builder',
      seeProcess: 'See process',
      buildSubject: 'Build Subject',
      subjectBuilderV2: 'Subject builder',
      resolveConflicts: 'Resolve conflicts'
    },
    all: {
      bookspurchased: 'Books purchased',
      coursespurchased: 'Subjects purchased',
    },
    loadMore: 'Load more',
    headerMenu: {
      purchased: 'Purchased',
      subjects: 'Subjects',
      templates: 'Templates',
      fileManager: 'File Manager'
    },
    makeTemplate: {
      confirmMsg: 'This subject cannot be published without content in it. Please go to Edit Subject Content.',
      confirmOk: 'Go to edit subject',
      confirmTemplate: 'Please select the visibility option for the template:',
      private: 'Private (Available for all teachers within your institution)',
      public: 'Public (Available for everyone on Eduac)',
      createdTitle: 'Templated created',
      createdBody: 'You can see it in the Bookstore section',
      errorBody: 'Sorry, there was an error trying to save the template. Try again',
      goToBookstore: 'Go to Bookstore'
    },
    makeSubject: {  
      errorBody: 'Sorry, there was an error trying to create the subject. Try again',
    },
    templates: {
      purchasedTemplates: 'Purchased Templates',
      myTemplates: 'My Templates',
      emptyPTMessage: 'You don\'t have purchased templates yet, but you can find these in the Bookstore.',
      emptyPTActionTitle: 'Go to Bookstore',
      createTemplate: 'Create template',
      iconPurchasedTooltip: 'Purchased Template. You cannot edit',
      sharedTemplates: 'Shared with me'
    },
    contentItem: {
      copying: 'Copying',
      error: 'Error',
      errorMessage: 'There was an error creating the Subject'
    }
  },
  es: {
    gridView: 'Vista de cuadrícula',
    listView: 'Vista de lista',
    confirmRemoveDraft: '¿Está seguro que quiere eliminar este borrador?',
    booksPurchased: 'Libros comprados',
    coursesPurchased: 'Cursos comprados',
    notItemsSection: 'No posees contenido en esta sección por el momento',
    view: 'Ver',
    editContent: 'Editar contenido',
    editProduct: 'Editar producto',
    removeDraft: 'Eliminar borrador',
    download: 'Descargar',
    cover: 'Portada',
    title: 'Título',
    teacher: 'Profesor',
    subject: 'Tema',
    actions: 'Acciones',
    seeAll: 'Ver todo',
    by: 'Por: ',
    byMe: 'Por: Mi',
    createCourse: 'Crear curso',
    createBook: 'Crear libro',
    draft: 'BORRADOR',
    uploading: 'SUBIENDO',
    conflict: 'CONFLICTO',
    statusSyncDone: 'Este está sincronizado',
    statusSyncPending: 'Este estaá sincronizandose justo ahora',
    statusSyncOut: 'Este aun no se sinconiza',
    statusSyncReadyDownload: 'Este puede usar el subject builder',
    itemMenu: {
      view: 'Ver',
      editContent: 'Editar contenido',
      editDescription: 'Editar descripción',
      copyToTemplate: 'Copiar a plantilla',
      copyToSubject: 'Copiar a curso',
      remove: 'Eliminar',
      download: 'Descargar',
      courseAdmin: 'Admin de curso',
      templateAdmin: 'Admin de la plantilla',
      subjectBuilder: 'Generador de cursos',
      seeProcess: 'Ver proceso',
      buildSubject: 'Construir Curso',
      subjectBuilderV2: 'Constructor de cursos',
      resolveConflicts: 'Resolver conflictos'
    },
    all: {
      bookspurchased: 'Libros comprados',
      coursespurchased: 'Cursos comprados',
    },
    loadMore: 'Cargar más',
    headerMenu: {
      purchased: 'Comprados',
      subjects: 'Cursos',
      templates: 'Plantillas',
      fileManager: 'Administrador de archivos'
    },
    makeTemplate: {
      confirmMsg: 'Este curso no puede ser publicado sin contenido. Por favor, ve al editor de curso',
      confirmOk: 'Ir al editor de curso',
      confirmTemplate: 'Por favor seleccione el tipo de visibilidad que tendrá la plantilla',
      private: 'Privada (Disponible solo para profesores de la institución)',
      public: 'Pública (Disponible por todos en Eduac)',
      createdTitle: 'Plantilla creada',
      createdBody: 'Puedes verla en la sección Bookstore',
      errorBody: 'Lo sentimos. Ocurrió un error intentando guardar la plantilla. Por favor intenta de nuevo.',
      goToBookstore: 'Ir a la tienda'
    },
    makeSubject: {  
      errorBody: 'Lo sentimos. Ocurrió un error intentando crear el curso. Por favor intenta de nuevo.',
    },
    templates: {
      purchasedTemplates: 'Plantillas compradas',
      myTemplates: 'Mis plantillas',
      emptyPTMessage: 'No tienes plantillas compradas aún. Pero puedes encontrarlas en la Tienda',
      emptyPTActionTitle: 'Ir a la tienda', 
      createTemplate: 'Crear plantilla',
      sharedTemplates: 'Compartidas conmigo',
      iconPurchasedTooltip: 'Plantilla comprada, no se puede editar.',
    },
    contentItem: {
      copying: 'Copiando',
      error: 'Error',
      errorMessage: 'Hubo un error creando la materia'
    }
  }
};